module.exports = __webpack_public_path__ + "static/img/cabecera.5977a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/gobierno-en/cabecera.jpg
// module id = Ugd8
// module chunks = 0